import { IQueryOptions, QueryKey, useQueryWrapper } from "./api-hooks-common";
import { InstantJobApi } from "../InstantJobApi";

// export const useGetInstantJobId = (config: InstantJobConfig, options?: IQueryOptions) => useQueryWrapper([QueryKey.INSTANT_JOBS, "config", config], () => InstantJobApi.enqueue(config), null, options);
export const useGetInstantJobStatus = (jobId: string, options?: IQueryOptions) =>
  useQueryWrapper(
    [QueryKey.INSTANT_JOBS, "status", jobId],
    () => InstantJobApi.getJobStatus(jobId),
    null,
    options
  );
export const useGetInstantJobData = (jobId: string, options?: IQueryOptions) =>
  useQueryWrapper(
    [QueryKey.INSTANT_JOBS, "data", jobId],
    () => InstantJobApi.getJobData(jobId),
    null,
    options
  );
